export function isChromeMobile() {
  return (
    !!navigator.userAgent.match('CriOS')
  )
  // return (
  //   /Chrome/.test(navigator.userAgent) && /Mobile/.test(navigator.userAgent)
  // );
}
